import { logEvent } from "../../analytics";

// Track page views
export const trackMemoCardPageView = (pageName) => {
  logEvent("MemoCard Page View", "memo-card", {
    page: pageName,
  });
};

// Track when user starts creating a card
export const trackMemoCardStarted = () => {
  logEvent("MemoCard Started", "memo-card", {
    timestamp: new Date().toISOString(),
  });
};

// Track question answers
export const trackQuestionAnswered = (questionIndex, questionText) => {
  logEvent("MemoCard Question Answered", "memo-card", {
    question_index: questionIndex,
    question_text: questionText,
    timestamp: new Date().toISOString(),
  });
};

// Track when user skips a question
export const trackQuestionSkipped = (questionIndex, questionText) => {
  logEvent("MemoCard Question Skipped", "memo-card", {
    question_index: questionIndex,
    question_text: questionText,
    timestamp: new Date().toISOString(),
  });
};

// Track when user completes all questions
export const trackQuestionsCompleted = (
  totalAnswered,
  totalSkipped,
  answers
) => {
  logEvent("MemoCard Questions Completed", "memo-card", {
    total_answered: totalAnswered,
    total_skipped: totalSkipped,
    completion_rate: (totalAnswered / (totalAnswered + totalSkipped)) * 100,
    answers,
    timestamp: new Date().toISOString(),
  });
};

// Track design selection
export const trackDesignSelected = (designId, designTitle) => {
  logEvent("MemoCard Design Selected", "memo-card", {
    design_id: designId,
    design_title: designTitle,
    timestamp: new Date().toISOString(),
  });
};

// Track when user reaches preview
export const trackPreviewReached = (totalQuestionsAnswered) => {
  logEvent("MemoCard Preview Reached", "memo-card", {
    total_questions_answered: totalQuestionsAnswered,
    timestamp: new Date().toISOString(),
  });
};

// Track share actions
export const trackCardShared = (shareMethod) => {
  logEvent("MemoCard Shared", "memo-card", {
    share_method: shareMethod, // 'native' or 'copy_link'
    timestamp: new Date().toISOString(),
  });
};

// Track when user abandons card creation
export const trackCardAbandoned = (lastPage, questionsAnswered) => {
  logEvent("MemoCard Abandoned", "memo-card", {
    last_page: lastPage,
    questions_answered: questionsAnswered,
    timestamp: new Date().toISOString(),
  });
};
